import { getP } from 'redux-polyglot'
import api from '../libs/api'
import { loadCart } from './cart'

/**
 * Actions for initializing the application
 */
export const INIT_APP_REQUEST = 'CHECKOUT/INIT_APP_REQUEST'

const initAppRequest = () => ({
  type: INIT_APP_REQUEST,
})

export const initApp = () => dispatch => {
  return Promise.all([
    dispatch(initAppRequest()),
    dispatch(loadCart()),
    dispatch(loadCurrentSubscriptions()),
  ])
}

/**
 * Actions for dismissing an error
 */
export const DISMISS_ERROR = 'CHECKOUT/DISMISS_ERROR'

export const dismissError = () => ({
  type: DISMISS_ERROR,
})

/**
 * Actions for fetching a list of current subscriptions for the user
 */
export const FETCH_CURRENT_SUBSCRIPTIONS_REQUEST =
  'CHECKOUT/FETCH_CURRENT_SUBSCRIPTIONS_REQUEST'
export const FETCH_CURRENT_SUBSCRIPTIONS_SUCCESS =
  'CHECKOUT/FETCH_CURRENT_SUBSCRIPTIONS_SUCCESS'
export const FETCH_CURRENT_SUBSCRIPTIONS_FAILURE =
  'CHECKOUT/FETCH_CURRENT_SUBSCRIPTIONS_FAILURE'

const fetchCurrentSubscriptionsRequest = () => ({
  type: FETCH_CURRENT_SUBSCRIPTIONS_REQUEST,
})

const fetchCurrentSubscriptionsSuccess = subscriptions => {
  const userSubscriptions = []
  if (subscriptions.web !== undefined && subscriptions.web.length > 0) {
    for (let i = 0; i < subscriptions.web.length; i++) {
      userSubscriptions.push({
        type: 'channel_group',
        id: subscriptions.web[i].id,
        name: subscriptions.web[i].name,
        price: subscriptions.web[i].price,
        channel_group_id: subscriptions.web[i].channel_group_id,
        gateway: {
          id: subscriptions.web[i].gateway.id,
          slug: subscriptions.web[i].gateway.slug,
        },
      })
    }
  }
  if (subscriptions.premium !== undefined && subscriptions.premium.length > 0) {
    for (let i = 0; i < subscriptions.premium.length; i++) {
      userSubscriptions.push({
        type: 'premium',
        id: subscriptions.premium[i].id,
        name: subscriptions.premium[i].name,
        price: subscriptions.premium[i].price,
        channel_id: parseInt(subscriptions.premium[i].channel.id, 10),
        gateway: {
          id: subscriptions.premium[i].gateway.id,
          slug: subscriptions.premium[i].gateway.slug,
        },
      })
    }
  }
  return {
    type: FETCH_CURRENT_SUBSCRIPTIONS_SUCCESS,
    payload: {
      subscriptions: userSubscriptions,
    },
  }
}

const fetchCurrentSubscriptionsFailure = error => ({
  type: FETCH_CURRENT_SUBSCRIPTIONS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const loadCurrentSubscriptions = () => (dispatch, getState) => {
  dispatch(fetchCurrentSubscriptionsRequest())
  return api
    .getCurrentSubscriptions()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(fetchCurrentSubscriptionsSuccess(response.subscriptions))
        } else {
          return dispatch(fetchCurrentSubscriptionsFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchCurrentSubscriptionsFailure(
            getP(getState()).t('checkout_app.error_loading_current_subscriptions', {
              _: 'An error has occurred while loading current subscriptions',
            })
          )
        )
    )
}
